module.exports = __webpack_public_path__ + "static/media/underline.d1767c1c.svg";